import React from "react"

function useAboutSong() {
  const audioRef = React.useRef(null)
  const [isPlaying, setIsPlaying] = React.useState(false)
  const wasMusicDisabled = React.useRef(true)
  React.useEffect(() => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.currentTime = 0
        audioRef.current.play()
      } else {
        audioRef.current.pause()
      }
    }
  }, [isPlaying])

  React.useEffect(() => {
    audioRef.current = new Audio(`${process.env.PUBLIC_URL}/audio/about.mpga`)
    const handleEnded = function () {
      this.currentTime = 0
      this.play()
    }
    audioRef.current.addEventListener("ended", handleEnded, false)

    return () => {
      audioRef.current.removeEventListener("ended", handleEnded, false)
    }
  }, [])

  return {
    isPlaying,
    play: () => {
      setIsPlaying(true)
    },
    stop: () => {
      audioRef.current.pause()
      wasMusicDisabled.current = true
      setIsPlaying(false)
    },
    wasMusicDisabled: wasMusicDisabled.current,
  }
}

export default useAboutSong
